import React, { ReactElement } from 'react'

function Loading({
  radius = 200,
  className,
}: {
  radius?: number
  className?: string
}): ReactElement {
  return (
    <svg
      className={`animate-spin text-denim fill ${className}`}
      width={radius}
      height={radius}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#58acf4"
        strokeWidth="10"
        r="30"
        strokeDasharray="141.37166941154067 49.12388980384689"
        transform="matrix(1,0,0,1,0,0)"
      ></circle>
    </svg>
  )
}

export default Loading
